import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-row-delete-dialog',
  templateUrl: './row-delete-dialog.component.html',
  styleUrls: ['./row-delete-dialog.component.scss']
})
export class RowDeleteDialogComponent implements OnInit {
  title:string="DELETE CONFIRMATION";
  text: string = "Are you sure you want to delete entire row values for all categories?";
  buttonSave: string = "Delete";
  buttonCancel: string ="Cancel";
  constructor( private dialogRef: MatDialogRef<RowDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      
       if(data && data.title){
        this.title = data.title;
        this.text = data.text;
        this.buttonSave = data.buttonSave;
        this.buttonCancel = data.buttonCancle;
       }else{
        this.title="DELETE CONFIRMATION";
        this.text = "Are you sure you want to delete entire row values for all categories?";
        this.buttonSave = "Delete";
        this.buttonCancel ="Cancel";
       }

     }

  ngOnInit() {
  }

}
